<ngx-loading-bar [color]="'#087e2a'" [includeSpinner]="false"></ngx-loading-bar>

<router-outlet></router-outlet>
